import { render, staticRenderFns } from "./appPrivacyResults.vue?vue&type=template&id=2a5c3978&scoped=true&"
import script from "./appPrivacyResults.vue?vue&type=script&lang=js&"
export * from "./appPrivacyResults.vue?vue&type=script&lang=js&"
import style0 from "./appPrivacyResults.vue?vue&type=style&index=0&id=2a5c3978&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a5c3978",
  null
  
)

export default component.exports